import useIsDesktop from 'hooks/useIsDesktop';
import React, {
  useContext, useEffect, useRef, useState,
} from 'react';
import ENDPOINTS from 'constants/endpoints';
import useConfig from 'hooks/useConfig';
import { useSearchParam } from 'react-use';
import useFetchedData from 'hooks/useFetchedData';
import ConfigProvider from 'components/ConfigProvider';
import { EMPTY_ARRAY } from 'constants';
import { AddressContext } from 'constants/contexts';
import MerchantsMapDesktop from './MerchantsMapDesktop';
import MerchantsMapMobile from './MerchantsMapMobile';

function MerchantsMap() {
  const isDesktop = useIsDesktop();
  const [filters, setFilters] = useState({});
  const { currentAddress } = useContext(AddressContext);
  const latParam = useSearchParam('lat');
  const lngParam = useSearchParam('lng');
  const defaultMapCenter = useConfig('pwa.defaultMapViewCenter');
  const locationParam = (latParam && lngParam && { lat: latParam, lng: lngParam });
  const currentAddressLocation = currentAddress && { lat: currentAddress?.lat, lng: currentAddress?.lng };
  const lastCenterRef = useRef(null);
  const { loading, data: merchants } = useFetchedData({
    url: ENDPOINTS.GET_ALL_MERCHANTS,
    query: {
      // ...(filters.center || locationParam || defaultMapCenter || {}), // number of merchants is limited so fetch all is not a problem
      organization: ConfigProvider.ORG_ID,
      has_delivery: filters.hasDelivery ? 'True' : undefined,
      serialize_availability: 'true',
      is_catering: 'True',
      query: '{id,slug,logo,name,images,location,address,availability}',
    },
  }, (data) => data?.results || EMPTY_ARRAY);
  const [selectedMerchant, setSelectedMerchant] = useState();

  useEffect(() => {
    setSelectedMerchant(null);
  }, [filters]);

  const center = selectedMerchant?.location ||
    filters.center ||
    lastCenterRef.current ||
    defaultMapCenter ||
    locationParam ||
    merchants[0]?.location ||
    currentAddressLocation ||
    { lat: 45.974313, lng: -104.027371 };

  useEffect(() => {
    if (center.lat && center.lng) {
      lastCenterRef.current = center;
    }
  }, [center.lat, center.lang]);

  return isDesktop ? (
    <MerchantsMapDesktop
      filters={filters}
      loading={loading}
      setFilters={setFilters}
      merchants={merchants}
      center={center}
      selectedMerchant={selectedMerchant}
      setSelectedMerchant={setSelectedMerchant}
    />
  ) : (
    <MerchantsMapMobile
      filters={filters}
      loading={loading}
      setFilters={setFilters}
      merchants={merchants}
      center={center}
      selectedMerchant={selectedMerchant}
      setSelectedMerchant={setSelectedMerchant}
    />
  );
}

export default MerchantsMap;
